/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from '../providers/api/api';

@Injectable()
export class ProductControlService extends Api {
  private base: string;
  /* add item to wish list api*/

  public addToWishlist(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(
      this.base + 'customer/add-product-to-wishlist',
      params
    );
  }
  /* get payment settings api*/

  public getPaymentSettings(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'list/get-payment-setting', {
      params: params
    });
  }

  /* get payment settings api*/
  public completeOrder(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'orders/success', params);
  }
  /* call checkout api*/

  public CheckoutProduct(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'orders/customer-checkout', params);
  }

  /* get payment settings api*/
  public servicePayment(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'vendor/booking-request/create-payment', params);
  }

  /* check availability of the product*/

  public CheckProductAvailability(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'vendor-store/check-pincode-availability', { params: params });
  }

  public getBooking(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'vendor/booking-request/view/' + params.id);
  }

  public getQuote(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'quote/view/' + params.id);
  }

  public updateQuotePayment(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'quote/update-quote-payment/' + params.id);
  }


  public updateFinalQuotePayment(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'quote/update-final-payment/' + params.id);
  }

  /* app applyCoupon of the product*/

  public applyCoupon(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'customer-coupon/apply-coupon', params);
  }

  /** do backorder checkout */

  public backorderCheckout(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'orders/back-order-checkout', params);
  }

  /** make quatation */

  public makeQuatation(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'quotation/quotation-request', params);
  }

  public saveCheckout(params: any): Observable<any> {
    const cartList = params.productDetails.product;
    params.productDetails = cartList;
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'orders/save-checkout', params);
  }

  public createOrder(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'orders/create-paypal-order', params);
  }

}
